module.exports = __webpack_public_path__ + "static/media/ss.5b2c57b8.jpg";